import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import i18next from 'i18next';
import { hasValue } from '@famly/stat_ts-utils_has-value';
import { useTransformQuery } from '@famly/vet_apollo-utils_use-transform-query';
import { accessToken, isPinApp, getSiteId, isQrSignin } from 'signin-app/login/selectors';
import { isAuthorized } from 'signin-app/pin/selectors';
import { didPrefetch } from 'signin-app/components/private-route/selectors';
import RoutesMap from 'signin-app/routes/routes-map';
import * as Queries from 'signin-app/login/queries';
import { saveIsQRSigninAvailable } from 'signin-app/api/helpers/local-storage';
import * as LoginActions from 'signin-app/login/actions';
import { Spinner } from '@famly/mf_feedback_spinner';
import { Stack } from '@famly/mf_layout_stack';
import useTypedSelector from '../hooks/use-typed-selector';
import * as Actions from './actions';
const PrivateRoute = (props) => {
    const { redirectTo = '/', component: Component, path, shouldPrefetch, ...rest } = props;
    const dispatch = useDispatch();
    const siteId = useTypedSelector(getSiteId);
    const authorized = useTypedSelector(isAuthorized);
    const token = useTypedSelector(accessToken);
    const prefetched = useTypedSelector(didPrefetch);
    const pinSigninEnabled = useTypedSelector(isPinApp);
    const isQRSigninEnabled = useTypedSelector(isQrSignin);
    const [qrEnabledFromNetwork, { loading }] = useTransformQuery()(Queries.GetQRSignInSettings, siteId ? { variables: { siteIds: [siteId] }, fetchPolicy: 'network-only' } : { fetchPolicy: 'network-only' }, ({ data }) => {
        var _a;
        return (_a = data === null || data === void 0 ? void 0 : data.qrSignin.siteSettings.siteSettings[0]) === null || _a === void 0 ? void 0 : _a.isEnabled;
    });
    React.useEffect(() => {
        if (shouldPrefetch && !prefetched && authorized && !pinSigninEnabled) {
            dispatch(Actions.prefetch.action(token));
        }
    }, [token, prefetched, authorized, pinSigninEnabled, props, shouldPrefetch, dispatch]);
    React.useEffect(() => {
        if (!loading && authorized && hasValue(qrEnabledFromNetwork) && isQRSigninEnabled !== qrEnabledFromNetwork) {
            saveIsQRSigninAvailable(Boolean(qrEnabledFromNetwork));
            dispatch(LoginActions.qrSigninChange.action(Boolean(qrEnabledFromNetwork)));
        }
    }, [loading, qrEnabledFromNetwork, isQRSigninEnabled, dispatch, authorized]);
    // Disable access to routes other than /qr if QR sign in enabled and PIN sign in disabled
    // Disable access to /qr route if QR sign in is not enabled
    const canAccessRoute = React.useMemo(() => {
        if ((path !== RoutesMap.qr && isQRSigninEnabled && !pinSigninEnabled) ||
            (path === RoutesMap.qr && !isQRSigninEnabled)) {
            return false;
        }
        return authorized;
    }, [authorized, pinSigninEnabled, isQRSigninEnabled, path]);
    if (loading) {
        _jsx(Stack, { justifyContent: "center", width: "100%", children: _jsx(Spinner, { size: 32, "aria-label": i18next.t($ => $.react.components.loading.spinner.translations.json.loadingAriaLabel) }) });
    }
    return (_jsx(Route, { ...rest, path: path, render: props => canAccessRoute ? (_jsx(Component, { ...props })) : (_jsx(Redirect, { to: {
                pathname: redirectTo,
            } })) }));
};
export default PrivateRoute;
